import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-close\"><path d=\"m12.7 4-.7-.7-4 4-4-4-.7.7 4 4-4 4 .7.7 4-4 4 4 .7-.7-4-4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol